import React, { useEffect, useState } from 'react'
import DeleteConfirmationPopUp from '../../../reused-components/DeleteConfirmationPopUp'
import {EDIT_POP_UP} from '../../../../constants/translations/customersPage'
import { useOnline } from '../../../../hooks/useOnline'
import { FULL_VIEW_ONLY, DEPARTMENT_ONLY, TASK_REMARK_ONLY, TASK_REMARK_QUANTITY_ONLY } from "../../../../tools/keys/variables"


const SubmitSectionNotMetalpress = (props) => {
    const onlineStatus = useOnline()
    const userPriveledges = props.userPriveledges
    const {CREATE_TASK} = EDIT_POP_UP
    const {
        closeMenu,
        submitForm,
        load_button,
        Loader, 
        isMobile, 
        createTask,
        canSave
    } = props

    const hasValidPrivilege = [FULL_VIEW_ONLY].some(priv =>
        userPriveledges.includes(priv)
    );

    const taskRemarkRole = userPriveledges.includes(TASK_REMARK_ONLY);
    const taskRemarkQuantityRole = userPriveledges.includes(TASK_REMARK_QUANTITY_ONLY);

    const departmentRole = userPriveledges.includes(DEPARTMENT_ONLY)
    const validPrivilege = departmentRole ? (hasValidPrivilege || !canSave) : hasValidPrivilege
    const canDisableSave = !(taskRemarkRole || taskRemarkQuantityRole) && validPrivilege;

    const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false)
    return (
        <section
            className="custom__popup__update__submit-section"
            style={isMobile ? ({ justifyContent: 'flex-end' }) : { justifyContent: 'space-between' }}
        >
            <div>
                {!isMobile ? <h3
                    onClick={createTask}
                    className='create_task_link'
                >{CREATE_TASK}</h3> : null}
            </div>
            <div>
                {load_button ? null : (
                    <button
                        onClick={() => {
                            onlineStatus ? closeMenu() : setConfirmationPopUpOpen(true)
                        }}
                    >
                        ביטול
                    </button>
                )}
                <button
                  disabled = {canDisableSave ? true : false } 
                  style={{
                    backgroundColor: canDisableSave ? '#cbcbcb' : undefined,
                  }}
                    onClick={() => {
                        submitForm()
                    }}
                >
                    {load_button ? <Loader /> : "שמור"}
                </button>
            </div>
            <DeleteConfirmationPopUp
                okCallback={() => closeMenu()}
                cancelCallback={() => setConfirmationPopUpOpen(false)}
                isOpen={confirmationPopUpOpen}
            />
        </section>
    )
}

export default SubmitSectionNotMetalpress